import React, { Fragment, useEffect, useState, useRef, useMemo } from "react";
import Select from "react-select";
import {
  AddIcon,
  FilterIcon,
  EditIcon,
  DeleteIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  LinkIcon,
  ApproveIcon,
  Disapprove,
  CSVIcon,
} from "../../../assets/icons/index";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import { IStandard } from "../../../model/interface/standard";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import {
  getStandards,
  deleteStandard,
  getAllStandards,
} from "../../../api/standard.service";
import { postAcademicsActivity } from "../../../api/academicsActivity.service";
import { IAcademicsActivity } from "../../../model/interface/academicsActivty";
import Constant from "../../../utils/constant";
import DeleteModal from "../../shared/common/deleteModal";
import Loader from "../../shared/loader/loader";
import { Link, useNavigate } from "react-router";
import ExportToCSV from "../../shared/common/exportToCsv";
import AddStandardGroup from "../../shared/common/addStandardGroup";
import { IStandardGroupDTO } from "../../../model/interface/standardGroup";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import { Menu, Transition } from "@headlessui/react";
import { toast } from "react-toastify";
import debounce from "lodash.debounce";
import StandardCopyPopup from "./standardCopy";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Standard() {
  const defaultPageNumber = 1;
  const defaultPageSize = 100;
  const defaultValue: ISelectElement = { label: "", value: "0" };
  const defaultElement: ISelectElement[] = [{ label: "", value: "0" }];
  const navigate = useNavigate();
  const [standards, setStandards] = useState<IStandard[]>([]);
  const [standardsBackUp, setStandardsBackUp] = useState<IStandard[]>([]);
  const [contentAreas, setContentAreas] = useState<ISelectElement[]>([]);
  const [subjects, setSubjects] = useState<ISelectElement[]>([]);
  const [domains, setDomains] = useState<ISelectElement[]>([]);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [showManagePopup, setShowManagePopup] = useState<boolean>(false);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [standardDelete, setStandardDelete] = useState<number>(0);
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [filterName, setFilterName] = useState<string>("");
  const [filterCode, setFilterCode] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [selectedContent, setSelectedContent] =
    useState<ISelectElement>(defaultValue);
  const [selectedSubject, setSelectedSubject] =
    useState<ISelectElement>(defaultValue);
  const [selectedDomain, setSelectedDomain] =
    useState<ISelectElement>(defaultValue);
  const [filterActive, setFilterActive] = useState<boolean>(true);
  const [sortAscending, setSortAscending] = useState<boolean>(true);
  const [orderByColumn, setOrderByColumn] = useState<string>("");
  const [sortDir, setSortDir] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [filterStandardId, setFilterStandardId] = useState<number>();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [standardGroupInfo, setStandardGroupInfo] = useState<any>({
    subjectId: 0,
    standardId: 0,
    domainId: 0,
    existingStandardGroups: [],
  });
  const childRef: any = useRef(undefined);
  const [options, setOptions] = useState<any>([]);
  const [linked, setLinked] = useState<boolean>(false);
  const [unlinked, setUnlinked] = useState<boolean>(false);
  const [all, setAll] = useState<boolean>(true);
  const [active, setActive] = useState<boolean>(false);
  const [inactive, setInactive] = useState<boolean>(false);
  const [inactiveActive, setInactiveActive] = useState<boolean>(true);

  const [selectedStandards, setSelectedStandards] = useState<Array<number>>([]);
  const [isCopyDisalbed, setIsCopyDisalbed] = useState(true);
  const [showStandardPopup, setShowStandardPopup] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);

  function showAddPopup() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const paramValue = params.get("add");
    if (paramValue && paramValue === "true") {
      setShowManagePopup(true);
    }
  }

  function onStandardSelect(standardId: number) {
    const standardIndex: number = selectedStandards.indexOf(standardId);
    if (standardIndex !== -1) {
      const filterdArray = selectedStandards.filter((r) => {
        return r !== standardId;
      });
      setSelectedStandards(filterdArray);
      setIsCopyDisalbed(filterdArray.length === 0);
    } else {
      selectedStandards.push(standardId);
      setSelectedStandards(selectedStandards);
      setIsCopyDisalbed(false);
    }
  }

  async function bindContentAreas() {
    const service = await import("../../../api/contentArea.service");
    service.getContentArea(999, 1).then((response) => {
      let newContentData: ISelectElement[] = [];
      if (response.data.data.length > 0) {
        newContentData = response.data.data.map((eachContentData) => {
          return {
            value: eachContentData.contentAreaId || 0,
            label: `${eachContentData.name}`,
          };
        });
      }
      setContentAreas(newContentData);
    });
  }

  async function bindSubjects(contentId: number) {
    const service = await import("../../../api/subject.service");
    service.getSubjectAllByContent(contentId).then((response) => {
      let newSubjects: ISelectElement[] = [];
      if (response.data.length > 0) {
        newSubjects = response.data.map((eachSubject) => {
          return {
            value: eachSubject.subjectId || 0,
            label: `${eachSubject.subjectName}`,
          };
        });
      }
      setSubjects(newSubjects);
    });
  }

  async function bindDomains(subjectId: number) {
    const service = await import("../../../api/domain.service");
    service.getAllDomainsBySubject(subjectId).then((response) => {
      let newDomains: ISelectElement[] = [];
      if (response.data.data.length > 0) {
        newDomains = response.data.data.map((eachDomain) => {
          return {
            value: eachDomain.domainId || 0,
            label: `${eachDomain.name}`,
          };
        });
      }
      setDomains(newDomains);
    });
  }

  function handleSort(columnName) {
    setLoading(true);
    setOrderByColumn(columnName);
    setSortAscending(!sortAscending);
    setSortDir(sortAscending ? "DESC" : "ASC");
    const names = formatFilterName(filterName);

    const standard: IStandard = {
      name: names,
      contentAreaId: selectedContent.value,
      subjectId: selectedSubject.value,
      domainId: selectedDomain.value,
      code: filterCode,
      isActive: active,
      description: "",
      loadOrder: 0,
      pageSize: pageSize,
      pageNumber: pageNumber,
      orderbyColumn: columnName,
      sortDir: sortAscending ? "DESC" : "ASC",
      standardId: filterStandardId,
      all: all,
      activeInactive: inactiveActive,
      isLinked: linked,
    };

    getStandards(standard).then((response: any) => {
      setStandards(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / pageSize));
      setLoading(false);
    });
  }

  function filterStandards() {
    setIsInitialLoad(false);
    setLoading(true);
    setIsFilter(true);

    const names = formatFilterName(filterName);

    const standard: IStandard = {
      name: names,
      contentAreaId: selectedContent !== null ? selectedContent.value : "0",
      subjectId: selectedSubject !== null ? selectedSubject.value : "0",
      domainId: selectedDomain !== null ? selectedDomain.value : "0",
      code: filterCode,
      isActive: active,
      description: description,
      loadOrder: 0,
      pageSize: defaultPageSize,
      pageNumber: defaultPageNumber,
      orderbyColumn: orderByColumn,
      sortDir: sortDir,
      standardId: filterStandardId,
      isLinked: linked,
      activeInactive: inactiveActive,
      all: all,
    };

    getStandards(standard)
      .then((response: any) => {
        setStandards(response.data.data);
        setTotalPages(Math.ceil(response.data.totalRecords / defaultPageSize));
        setTotalRecords(response.data.totalRecords);
        paginationRef?.current?.onReset();
        pageSizeRef?.current?.onReset();
        setIsFilter(false);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(`${error.message} Cannot retrieve standards.`);
      });

    pageSizeRef?.current?.onReset();
  }

  const resetFilterHandler = () => {
    setFilterName("");
    setFilterCode("");
    setDescription("");
    setStandards(standardsBackUp);
    setResetDropdownFlag(!resetDropdownFlag);
    setFilterActive(true);
    bindStandards(true);
    setSelectedContent(defaultValue);
    setSubjects(defaultElement);
    setSelectedSubject(defaultValue);
    setDomains(defaultElement);
    setSelectedDomain(defaultValue);
    setFilterStandardId(0);
    setInactiveActive(true);
    setActive(false);
    setInactive(false);
    setLinked(false);
    setUnlinked(false);
    setAll(true);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };

  function bindStandards(isReset?) {
    if (isInitialLoad) {
      return false;
    }

    setLoading(true);

    const names = formatFilterName(filterName);

    const standard: IStandard = {
      name: isReset ? "" : names ? names : "",
      contentAreaId: isReset
        ? "0"
        : selectedContent.value
        ? selectedContent.value
        : "0",
      subjectId: isReset
        ? "0"
        : selectedSubject.value
        ? selectedSubject.value
        : "0",
      domainId: isReset
        ? "0"
        : selectedDomain.value
        ? selectedDomain.value
        : "0",
      code: isReset ? "" : filterCode ? filterCode : "",
      isActive: isReset ? undefined : active,
      description: isReset ? "" : description ? description : "",
      loadOrder: 0,
      pageSize: isReset ? defaultPageSize : pageSize,
      pageNumber: isReset ? defaultPageNumber : pageNumber,
      standardId: isReset ? 0 : filterStandardId,
      orderbyColumn: orderByColumn,
      sortDir: sortDir,
      isLinked: isReset ? undefined : linked,
      all: all,
      activeInactive: inactiveActive,
    };

    getAllStandards(standard).then((response: any) => {
      setStandards(response.data.data);
      setStandardsBackUp(response.data.data);
      setTotalPages(
        Math.ceil(
          response.data.totalRecords / (isReset ? defaultPageSize : pageSize)
        )
      );
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
  }

  const formatFilterName = (filterName: string): string => {
    if (filterName.trim().length === 0) return "";

    const names = filterName
      .trim()
      .split(" ")
      .map((name) => `"${name}*"`)
      .join(" OR ");
    console.log(names);
    return names;
  };

  function confirmDelete(idToDelete?: string) {
    if (idToDelete) {
      setShowDeletePopup(true);
      setStandardDelete(parseInt(idToDelete));
    }
  }

  function deleteRecord() {
    deleteStandard(standardDelete).then(() => {
      setShowDeletePopup(false);
      setStandardDelete(0);
      const academicsActivity: IAcademicsActivity = {
        Name: "Standard",
        ActivityTypeId: Constant.ACADEMICSACTYVITYTYPE.DELETE,
        UpdatedByUserId: 1,
      };
      postAcademicsActivity(academicsActivity);
      bindStandards(true);
      resetFilterHandler();
      toast.success("Deleted successfully");
    });
  }

  function closeDeletePopup() {
    setShowDeletePopup(false);
    setStandardDelete(0);
  }

  function handleShowPopup(show: boolean, rebindData?: boolean) {
    setShowManagePopup(show);
    if (rebindData) {
      bindStandards();
    }
  }

  function handleNameChange(e: any) {
    setFilterName(e.target.value);
  }

  function handleCodeChange(e: any) {
    setFilterCode(e.target.value);
  }

  function handleDomainChange(selectedItem: any) {
    setSelectedDomain(selectedItem);
  }

  function handleContentAreaChange(e: any) {
    setSelectedContent(e);
    bindSubjects(e.value);
    setDomains(defaultElement);
    setSelectedDomain(defaultValue);
    setSelectedSubject(defaultValue);
  }

  function handleSubjectChange(selectedItem: any) {
    setSelectedSubject(selectedItem);
    bindDomains(selectedItem.value);

    setDomains(defaultElement);
    setSelectedDomain(defaultValue);
  }

  const handleRedirect = (id?: number | string) => {
    navigate(
      id
        ? Constant.EDITSTANDARD.replace(":id", id.toString())
        : Constant.ADDSTANDARD,
      { state: { idToEdit: id } }
    );
  };

  useEffect(() => {
    bindContentAreas();
    bindSubjects(0);
    bindDomains(0);
    showAddPopup();
  }, []);

  useEffect(() => {
    if (isLoaded && !isFilter) bindStandards();
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      bindStandards();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  function handleStandardIdChange(e: any) {
    setFilterStandardId(e.target.value);
  }

  const inputValue: any = [];
  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    const input = document.getElementById("standardId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.,]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }

    const multiSelectInput: any =
      document.querySelector(".css-ci43kd-Input input") ||
      document.querySelector(".css-z0e8fs-Input input");
    const multiSelectInputServer: any =
      document.querySelector(".css-912qm0 input") ||
      document.querySelector(".css-1446j1a input");

    if (multiSelectInput) {
      multiSelectInput?.addEventListener("input", debouncedChangeHandler);
    } else {
      multiSelectInputServer?.addEventListener("input", debouncedChangeHandler);
    }

    const arrow: any = document.querySelector(
      ".css-1hb7zxy-IndicatorsContainer"
    );
    if (arrow) {
      arrow.style.display = "none";
    }

    const arrows: any = document.querySelector(".css-1wy0on6");
    if (arrows) {
      arrows.style.display = "none";
    }
  }, []);

  const onNameChange = (e) => {
    const menu: any = document.querySelector(".css-26l3qy-menu");

    if (menu) {
      menu.style.display = "none";
    }
    options.push({ label: e.target.value, value: e.target.value });
    setOptions([]);
    setOptions(options);
  };

  const debouncedChangeHandler = useMemo(() => debounce(onNameChange, 100), []);

  const handleAddStandardGroup = (
    standardId: number,
    domainId: number,
    subjectId: number,
    standardGroups: Array<IStandardGroupDTO>
  ) => {
    const standardGroupProps: any = {
      subjectId: subjectId,
      domainId: domainId,
      standardId: standardId,
      existingStandardGroups: standardGroups,
    };
    setStandardGroupInfo(standardGroupProps);
    setShowConfirmation(true);
  };

  const exportFn = async () => {
    setLoading(true);

    const names = formatFilterName(filterName);

    const standard: IStandard = {
      name: names,
      contentAreaId: selectedContent !== null ? selectedContent.value : "0",
      subjectId: selectedSubject !== null ? selectedSubject.value : "0",
      domainId: selectedDomain !== null ? selectedDomain.value : "0",
      code: filterCode,
      isActive: active,
      description: description,
      loadOrder: 0,
      pageSize: defaultPageSize,
      pageNumber: defaultPageNumber,
      orderbyColumn: orderByColumn,
      sortDir: sortDir,
      standardId: filterStandardId,
      isLinked: linked,
      all: all,
      activeInactive: inactiveActive,
    };

    const response = getStandards(standard);
    const data = (await response).data;
    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "standards.csv");
    } else {
      toast.warning("No records to download");
    }
  };
  const toggleLinks = (tab: string) => {
    if (tab === "Linked") {
      setLinked(true);
      setUnlinked(false);
      setAll(false);
    } else if (tab === "Unlinked") {
      setLinked(false);
      setUnlinked(true);
      setAll(false);
    } else {
      setLinked(false);
      setUnlinked(false);
      setAll(true);
    }
  };
  const toggleIsActive = (tab: string) => {
    if (tab === "Active") {
      setActive(true);
      setInactive(false);
      setInactiveActive(false);
    } else if (tab === "Inactive") {
      setActive(false);
      setInactive(true);
      setInactiveActive(false);
    } else {
      setActive(false);
      setInactive(false);
      setInactiveActive(true);
    }
  };

  return (
    <AllowedTo perform={Permissions.standard_view} no={() => <AccessDenied />}>
      {loading && <Loader />}

      {showDeletePopup && (
        <DeleteModal
          closeDeleteModal={closeDeletePopup}
          deleteRecord={deleteRecord}
        />
      )}

      <div className="flex-1">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-end justify-between">
              <h3 className="text-lg font-light text-gray-900">Standard</h3>
              <div>
                <AllowedTo perform={Permissions.standard_create}>
                  <button
                    onClick={() => handleRedirect()}
                    type="button"
                    className="mr-2 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                  >
                    <AddIcon className="w-5"></AddIcon>
                    Add Standard
                  </button>
                </AllowedTo>

                <AllowedTo perform={Permissions.standard_linking_view}>
                  <Link
                    to={Constant.STANDARDLINK}
                    className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                  >
                    <LinkIcon className="mr-1 w-5"></LinkIcon>
                    Linking
                  </Link>
                </AllowedTo>
              </div>
            </div>
            <div className="pt-6 border-b pb-6">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-3 sm:col-span-3  ">
                  <label className="text-sm text-gray-700">Standard Id</label>
                  <div className="contentArea mt-1">
                    <input
                      id="standardId"
                      name="standardId"
                      value={filterStandardId || ""}
                      onChange={handleStandardIdChange}
                      type="text"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3  ">
                  <label className="text-sm text-gray-700">Name</label>
                  <div className="contentArea mt-1">
                    <input
                      title="Name"
                      value={filterName}
                      onChange={handleNameChange}
                      type="text"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>
                <div className="col-span-3 sm:col-span-3  ">
                  <label className="text-sm text-gray-700">Code</label>
                  <div className="contentArea mt-1">
                    <input
                      id="Code"
                      name="Code"
                      value={filterCode}
                      onChange={handleCodeChange}
                      type="text"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>
                <div className="col-span-3 sm:col-span-3">
                  <label className="text-sm text-gray-700">Description</label>
                  <div className="contentArea mt-1">
                    <input
                      id="description"
                      name="description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      type="text"
                      className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    />
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3">
                  <label className="text-sm text-gray-700">Content Area</label>
                  <div className="mt-1">
                    <Select
                      placeholder={""}
                      options={contentAreas}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                      value={selectedContent}
                      onChange={handleContentAreaChange}
                      isSearchable={true}
                    ></Select>
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3">
                  <label className="text-sm text-gray-700">Subject</label>
                  <div className="mt-1">
                    <Select
                      placeholder={""}
                      options={subjects}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                      value={selectedSubject}
                      onChange={handleSubjectChange}
                      isSearchable={true}
                    ></Select>
                  </div>
                </div>

                <div className="col-span-3 sm:col-span-3">
                  <label className="text-sm text-gray-700">Domain</label>
                  <div className="mt-1">
                    <Select
                      placeholder={""}
                      options={domains}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                      value={selectedDomain}
                      onChange={handleDomainChange}
                    />
                  </div>
                </div>
                <div className="col-span-3 flex items-center">
                  <div className="flex items-end mt-6 mr-2 justify-end">
                    <div className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md">
                      <span
                        onClick={() => toggleLinks("Linked")}
                        className={`${
                          linked
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } inline-block dark:text-white py-0.5 px-2 text-sm  text-center cursor-pointer hover:opacity-80`}
                      >
                        Linked
                      </span>
                      <span
                        onClick={() => toggleLinks("All")}
                        className={`${
                          all
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } py-0.5 px-2 inline-block text-center text-sm  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                      >
                        Both
                      </span>
                      <span
                        onClick={() => toggleLinks("Unlinked")}
                        className={`${
                          unlinked
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } py-0.5 px-2 inline-block text-center text-sm  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                      >
                        Unlinked
                      </span>
                    </div>
                  </div>

                  <div className="flex items-end mt-6 justify-end">
                    <div className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md">
                      <span
                        onClick={() => toggleIsActive("Active")}
                        className={`${
                          active
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } inline-block dark:text-white py-0.5 px-2 text-sm  text-center cursor-pointer hover:opacity-80`}
                      >
                        Active
                      </span>
                      <span
                        onClick={() => toggleIsActive("all")}
                        className={`${
                          inactiveActive
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } py-0.5 px-2 inline-block text-center text-sm  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                      >
                        Both
                      </span>
                      <span
                        onClick={() => toggleIsActive("Inactive")}
                        className={`${
                          inactive
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } py-0.5 px-2 inline-block text-center text-sm  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                      >
                        Inactive
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="flex justify-start">
                <button
                  type="submit"
                  className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  onClick={() => filterStandards()}
                >
                  <FilterIcon className="w-3 h-3"></FilterIcon>
                  <span>Filter</span>
                </button>
                <button
                  type="button"
                  className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  onClick={resetFilterHandler}
                >
                  <ResetIcon className="w-3 h-3"></ResetIcon>
                  <span>Reset Filter</span>
                </button>
                <button
                  type="button"
                  disabled={isCopyDisalbed}
                  className="disabled:opacity-50 mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  onClick={() => {
                    setShowStandardPopup(true);
                  }}
                >
                  <span>Copy to domain</span>
                </button>

                <button
                  type="button"
                  onClick={() => exportFn()}
                  className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                  <span>Export</span>
                </button>
                <ExportToCSV ref={childRef} />
              </div>
            </div>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th className="w-8 rounded-tl-lg"></th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider w-32"
                            >
                              <span className="flex gap-2">
                                Id
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "standardId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("standardId")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("standardId")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                            >
                              <span className="flex gap-2">
                                Code
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "code" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("code")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("code")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Name
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "name" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("name")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("name")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              Domain
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              Subject
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider rounded-tr-lg"
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {standards.map((standard: any, index) => (
                            <tr
                              key={standard.standardId}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-100"
                              }
                            >
                              <td className="pl-3 relative w-18 flex">
                                {standard.isActive ? (
                                  <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                ) : (
                                  <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                )}
                                <input
                                  type="checkbox"
                                  className="ml-2 mr-2"
                                  onChange={() => {
                                    onStandardSelect(standard.standardId);
                                  }}
                                />
                                {standard.isLinked && (
                                  <LinkIcon
                                    className={`cursor-not-allowed w-5 ${
                                      standard.isLinked ? "" : "opacity-50"
                                    }`}
                                  />
                                )}
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500 ">
                                <Link
                                  to={Constant.EDITSTANDARD.replace(
                                    ":id",
                                    standard.standardId
                                      ? standard.standardId.toString()
                                      : ""
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {standard.standardId}
                                </Link>
                              </td>
                              <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  to={Constant.EDITSTANDARD.replace(
                                    ":id",
                                    standard.standardId
                                      ? standard.standardId.toString()
                                      : ""
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {standard.code}
                                </Link>
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                <div className="flex items-center">
                                  <Link
                                    to={Constant.EDITSTANDARD.replace(
                                      ":id",
                                      standard.standardId
                                        ? standard.standardId.toString()
                                        : ""
                                    )}
                                    className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  >
                                    {standard.standardIcon && (
                                      <img
                                        className="h-5 w-5 mr-2"
                                        src={standard.standardIcon}
                                      />
                                    )}
                                    {standard.name}
                                  </Link>
                                </div>
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  to={Constant.EDITDOMAIN.replace(
                                    ":id",
                                    standard.domainId
                                      ? standard.domainId.toString()
                                      : ""
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {standard.domainName}
                                </Link>
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  to={Constant.SUBJECTDETAIL.replace(
                                    ":id",
                                    standard.subjectId
                                      ? standard.subjectId.toString()
                                      : ""
                                  )}
                                  state={{ subjectType: 1 }}
                                  className="font-medium text-indigo-600 cursor-pointer hover:text-indigo-500 hover:underline"
                                >
                                  {standard.subjectName}
                                </Link>
                              </td>
                              <td className="flex whitespace-wrap text-sm text-center px-3 py-2 font-normal text-gray-700 relative justify-end">
                                <div className="flex justify-end items-center space-x-2">
                                  {standard.isApproved ? (
                                    <ApproveIcon title="Approved" />
                                  ) : (
                                    <Disapprove />
                                  )}

                                  <Menu
                                    as="div"
                                    className="flex justify-end items-center"
                                  >
                                    <Menu.Button className="h-7 bg-white inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bg-primary-color">
                                      <span className="sr-only">
                                        Open options
                                      </span>
                                      <DotsVerticalIcon
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                      />
                                    </Menu.Button>
                                    <Transition
                                      as={Fragment}
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <Menu.Items className="mx-3 origin-top-right absolute right-7 top-0  w-52 mt-1 rounded-md shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none">
                                        <div className="py-1">
                                          <AllowedTo
                                            perform={
                                              Permissions.standard_modify
                                            }
                                          >
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={() => {
                                                    handleAddStandardGroup(
                                                      standard.standardId,
                                                      standard.domainId,
                                                      standard.subjectId,
                                                      standard.standardGroups
                                                    );
                                                  }}
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <AddIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
                                                  Add Standard Group
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </AllowedTo>

                                          <AllowedTo
                                            perform={
                                              Permissions.standard_modify
                                            }
                                          >
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={() =>
                                                    handleRedirect(
                                                      standard.standardId
                                                    )
                                                  }
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <EditIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                                                  Edit
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </AllowedTo>
                                        </div>
                                        <AllowedTo
                                          perform={Permissions.standard_delete}
                                        >
                                          <div className="py-1">
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={() =>
                                                    confirmDelete(
                                                      standard.standardId
                                                    )
                                                  }
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <DeleteIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300" />
                                                  Delete
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </div>
                                        </AllowedTo>
                                      </Menu.Items>
                                    </Transition>
                                  </Menu>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  className={`flex justify-between items-center ${
                    standards.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                      defaultPage={defaultPageSize}
                    />
                  </span>
                </div>

                {standards.length === 0 && (
                  <p className="p-2">No Records Found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showConfirmation && (
        <AddStandardGroup
          {...standardGroupInfo}
          title={"Add Standard Group"}
          confirmAction={setShowConfirmation}
          buttonText={"Add"}
        />
      )}
      {showStandardPopup && (
        <StandardCopyPopup
          standardIds={selectedStandards}
          showPopUp={(e) => {
            setShowStandardPopup(false);
          }}
        />
      )}
    </AllowedTo>
  );
}

export default Standard;
